import { render, staticRenderFns } from "./inquiry_list.vue?vue&type=template&id=ad4eddc8&scoped=true"
import script from "./inquiry_list.vue?vue&type=script&lang=js"
export * from "./inquiry_list.vue?vue&type=script&lang=js"
import style0 from "./inquiry_list.vue?vue&type=style&index=0&id=ad4eddc8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4eddc8",
  null
  
)

export default component.exports